export default __webpack_public_path__ + "static/keep-contact-image-449eca03a9ed39fc1b716045467fb9c3.png";